import React, { useState, useEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Home from "./views/Home";
import Dash from "./views/Dashboard";
import TimeCalc from "./views/TimeCalc";
import IncomeStream from "./views/IncomeStream";
import { Login } from "./views/Login";
import { Register } from "./views/Register";
import { useHistory, useParams, useLocation } from "react-router-dom";
import Landing from "./views/Landing";
import { Forgot } from "./views/ForgotPassword";
import { Reset } from "./views/ResetPassword";
import { Change } from './views/ChangeEmail';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Setting from "./views/Setting";
import Tutorial from "./components/onboarding/tutorialLanding";
import TutorialStream from "./components/onboarding/tutorialTracker";
import cs from "classnames";
//import { checkAuth } from './utils/checkAuth';
//import useToken from './components/useToken';
import AuthService from "./services/auth";
import { useDispatch, useSelector } from "react-redux";

import { isLoggedIn } from "./utils/utility";
import ReactGA from "react-ga";

import "rsuite/dist/styles/rsuite-default.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Questions from "./components/Questions";
import Calculator from "./views/Calculator";
import Mode from "./components/Mode";
import { themModeSelector } from "./redux/selectors/AuthSelectors";
import { themActions } from "./redux/actions/AuthAction";
import { Etsy } from "./views/Etsy";
import CalculatorSummarySheet from "./components/CalculatorSummarySheet";
import SignupMessage from "./views/SignupMessage";

ReactGA.initialize("UA-222467302-2"); //G-BDNR3RLJHR

const initGA = () => {
  ReactGA.initialize("UA-222467302-2"); // { debug: true } UA-222467302-1
};

function setToken(userToken) {
  sessionStorage.setItem("token", JSON.stringify(userToken));
  //console.log("token2");
}

function getToken() {
  const tokenString = sessionStorage.getItem("token") || "{}";
  const userToken = JSON.parse(tokenString);
  return userToken?.token;
}

function App() {
  const history = useHistory();
  const user = AuthService.getCurrentUser();
  const dispatch = useDispatch();
  const { isDarkMode } = useSelector(themModeSelector);

  // useEffect(() => {
  //   if (success) {
  //     history.push("/login");
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [success]);

  const handleLogout = () => {
    AuthService.logout();
    history.push("/");
  };

  useEffect(() => {
    initGA();
    const themeStore = localStorage.getItem("themMode");
    dispatch(themActions(themeStore === "true"));
  }, []);

  useEffect(() => {
    const script = document.createElement("script");

    script.src = "//code.tidio.co/h5bgsrptmescpsacnt14lf3d7j4fkzrg.js";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const token = getToken();

  useEffect(() => {
    const body = document.getElementsByTagName("body")[0];
    if (isDarkMode) {
      body.style.background = "#212121";
      body.style.color = "#fff";
      body.classList.add("dark-mode");
    } else {
      body.style.background = "#fff";
      body.style.color = "#2e2e2e";
      body.classList.remove("dark-mode");
    }
    localStorage.setItem("themMode", isDarkMode);
  }, [isDarkMode]);

  return (
    <>
      <BrowserRouter>
        <div className={cs("main-page-wrapper")}>
          <ToastContainer autoClose={15000} />
          <Route exact path="/" component={Landing} />
          {/*<Route path='/dashboard' component={Dash} />*/}
          <Route path="/auth/login" component={Login} />
          <Route path="/auth/register" component={Register} />
          <Route path="/auth/forgotPassword" component={Forgot} />
          <Route path="/auth/resetPassword" component={Reset} />
          <Route path='/auth/confirmEmail' component={Change} />
          <Route path="/mobile" component={SignupMessage}></Route>
          <Route path="/home" component={Home} />
          <Route path="/settings" component={Setting} />
          {/* <Route exact path="/auth/logout" render={handleLogout} /> */}
          <Route path="/calc" component={TimeCalc} />
          <Route exact path="/stream/:name" component={IncomeStream} />
          <Route path="/stream/:name/calculator" component={Calculator} />
          <Route path="/tutorial_stream/:name/calculator" component={Calculator} />
          <Route path="/landing" component={Landing} />
          <Route
            path="/calculateSummarySheet"
            component={CalculatorSummarySheet}
          />
          <Route path="/tutorial" component={Tutorial} />
          <Route exact path="/tutorial_stream/:name" component={TutorialStream} />
          <Route path="/onboarding" component={Questions} />
          <Route path="/etsyShop" component={Etsy} />
        </div>
      </BrowserRouter>
    </>
  );
}

export default App;
